import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
document.title = 'De Rien Cash Loan';
render(<App data-id="element-562" />, document.getElementById('root'));